<template>
  <div class="columns">
    <div class="column is-8">
      <label class="label">
        <span v-if="isUploaded" class="icon is-normal has-text-success">
          <font-awesome-icon icon="check" />
        </span>
        <span v-if="isUploadError" class="icon is-normal has-text-danger">
          <font-awesome-icon icon="times" />
        </span>
        Geometry Upload
        <font-awesome-icon
          icon="info-circle"
          title="Accepted formats: .sab .sat .sm3 .AnsrGeom .dxf .dwg .ipt .iam .exp .model .CATPart .CATProduct .prt .as .gds .iges .igs .nas .prt .x_t .x_b .SLDPRT .SLDASM .step .stp and .stl."
          style="cursor: help;"
        />
      </label>
      <div class="file has-name is-fullwidth halfVerticalSpace">
        <label class="file-label">
          <input
            class="file-input"
            name="file"
            type="file"
            ref="file"
            v-on:change="handleFileUpload()"
            id="step1-device-geometry-upload-file"
          />
          <span class="file-cta">
            <span class="file-icon">
              <font-awesome-icon icon="upload" />
            </span>
            <span class="file-label">Choose a file…</span>
          </span>
          <span class="file-name my-file-name">{{file.name}}</span>
        </label>
      </div>
      <p
        class="help is-large"
      >Supports single component geometries that fit within the ASTM phantom volume.</p>
    </div>
  </div>
</template>

<script>
const forbiddenModelFilename = /^(con|prn|aux|nul|com[0-9]|lpt[0-9])$|([<>:"\/\\|?*])|(\.|\s)$/ig;
const allowedModelFileExtensions = ['sab', 'sat', 'sm3', 'AnsrGeom', 'dxf', 'dwg', 'ipt', 'iam', 'exp', 'model', 'CATPart', 'CATProduct', 'prt', 'as', 'gds', 'iges', 'igs', 'nas', 'prt', 'x_t', 'x_b', 'SLDPRT', 'SLDASM', 'step', 'stp', 'stl'];

function validateFile(file) {
  if (file) {
    if (file.name !== '') {
      if (forbiddenModelFilename.test(file.name)) {
        return `Invalid filename \`${file.name}\` for model.`;
      }
      const extension = file.name.split('.').pop();
      if (allowedModelFileExtensions.includes(extension)) {
        return true;
      }
      return `File of type ${extension} not accepted. Must be one of ${allowedModelFileExtensions.join(', ')}.`;
    }
    return 'Filename empty.';
  }
  return 'File not found.';
}

export default {
  data() {
    return {
      isUploaded: false,
      isUploadError: false,
      file: '',
    };
  },
  methods: {
    handleFileUpload() {
      [this.file] = this.$refs.file.files;
      const validationTrueOrErrorMsg = validateFile(this.file);
      if (validationTrueOrErrorMsg === true) {
        this.isUploaded = true;
        this.isUploadError = false;
        this.$emit('fileUpload', this.file);
      } else {
        this.isUploaded = false;
        this.isUploadError = true;
        this.$utils.alertError(validationTrueOrErrorMsg);
      }
    },
  },
};
</script>

<style scoped>
.halfVerticalSpace {
  padding-top: 0.5em;
}
.oneVerticalSpace {
  padding-top: 1em;
}
span.my-file-name {
  min-width: 20em;
}
</style>
